import { algoliasearch, type SearchClient } from 'algoliasearch'

let algoliaClient: SearchClient | null = null

export const initializeAlgoliaClient = (apiKey: string): void => {
  algoliaClient = algoliasearch(import.meta.env.VITE_ALGOLIA_APP_ID, apiKey)
}

export const getAlgoliaClient = (): SearchClient => {
  if (!algoliaClient) {
    throw new Error('Algolia client not initialized')
  }
  return algoliaClient
}

export default getAlgoliaClient
